import { GridSortItem } from "@mui/x-data-grid";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { UserControllerApi } from "../services";
import {
  DGT_Pagination,
  asPaginatedContent,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseContent,
} from "../utils/utils";
import { UserCardData } from "../types/user-types";

interface UseUsersListProps {
  pagination: DGT_Pagination;
  gridSorting?: GridSortItem[];
  searchKey?: string;
  providerGroupId?: string;
  locationUuid?: string;
  role?: string;
  statusKey?: boolean;
  isArchieve?: boolean;
}

/**
 *
 * @author Shrinivas Mandhare
 */

export function useUsersList({
  gridSorting,
  pagination,
  searchKey,
  providerGroupId,
  locationUuid,
  role,
  statusKey,
  isArchieve,
}: UseUsersListProps): useBaseContent<UserCardData> {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey,
    prevPage,
  });
  const pageSize = getPageSize(searchKey, pagination);

  const sortDirect = gridSorting?.[0]?.sort ?? undefined;
  const sortBy = sortDirect ? "name" : undefined;

  return useQuery({
    queryKey: [
      "provider-group-users-list",
      pageSize,
      pageIndex,
      providerGroupId,
      locationUuid,
      searchKey,
      role,
      statusKey,
      gridSorting,
      isArchieve,
    ],
    placeholderData: keepPreviousData,
    enabled: providerGroupId !== undefined || providerGroupId !== null,
    refetchOnWindowFocus: false,
    queryFn: async () =>
      new UserControllerApi(getConfigObject())
        .getAllUsers(
          pageIndex,
          pageSize,
          sortBy, // sortBy
          sortDirect, // sortDirection
          statusKey, //status
          isArchieve, //archive
          role, //role
          "STAFF", //roleType
          locationUuid, //locationUuid
          searchKey, //searchString
          providerGroupId //xTENANTID
        )
        .then((it) => asPaginatedContent<UserCardData>(it?.data)),
  });
}
